import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint jsx-a11y/no-redundant-roles: 0 */
import React from 'react';
import classNames from 'classnames';
import Paragraph from "@scentregroup/ui/components/paragraph";
import { summariseOccurrences } from '../../../helpers/occurrences';
import AutoPotentialLink from '../../auto-potential-link';
import ResponsiveImage from '../../responsive-image';
import Trackable from '../../trackable';
import { trackingActions, trackingTypes } from '../../../constants';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const DeckCard = _ref => {
  var _analyticsMetadata$pr;

  let {
    className,
    body,
    image,
    link,
    externalLink,
    occurrences,
    location,
    onClick,
    clickEvent,
    analyticsMetadata,
    padded = false,
    trackers,
    index
  } = _ref;
  const hasOccurrences = Boolean(occurrences && occurrences.times && occurrences.times.length);
  return /*#__PURE__*/_jsx("li", {
    className: classNames(style.DeckCard, style.evolved, {
      [style.padded]: padded
    }, className),
    role: "listitem",
    "data-test-id": "card",
    "data-id": "deck-card_index_DeckCard_li",
    children: /*#__PURE__*/_jsx(Trackable, _objectSpread(_objectSpread({}, analyticsMetadata), {}, {
      trackingAction: trackingActions.viewPromotion,
      type: trackingTypes.promotion,
      creative: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : (_analyticsMetadata$pr = analyticsMetadata.promotion) === null || _analyticsMetadata$pr === void 0 ? void 0 : _analyticsMetadata$pr.creative,
      "data-id": "deck-card_index_DeckCard_li_Trackable",
      children: /*#__PURE__*/_jsxs(AutoPotentialLink, {
        link: link,
        className: style.link,
        external: externalLink,
        onClick: () => {
          var _trackers$clicked;

          onClick === null || onClick === void 0 ? void 0 : onClick();
          trackers === null || trackers === void 0 ? void 0 : (_trackers$clicked = trackers.clicked) === null || _trackers$clicked === void 0 ? void 0 : _trackers$clicked.call(trackers, body);

          if (clickEvent) {
            clickEvent(index !== null && index !== void 0 ? index : 0);
          }
        },
        "data-id": "deck-card_index_DeckCard_Trackable_AutoPotentialLink",
        children: [/*#__PURE__*/_jsx(ResponsiveImage, {
          className: style.image,
          desktopImageUrl: image,
          mobileImageUrl: image,
          mobileRatio: "square",
          desktopRatio: "square",
          numberOfItems: 4,
          alt: "",
          dataTestId: "card-image",
          "data-id": "deck-card_index_DeckCard_AutoPotentialLink_ResponsiveImage"
        }), /*#__PURE__*/_jsx("div", {
          className: style.cardBody,
          "data-id": "deck-card_index_DeckCard_AutoPotentialLink_div",
          children: /*#__PURE__*/_jsxs("div", {
            className: style.cardInner,
            "data-test-id": "card-details",
            "data-id": "deck-card_index_DeckCard_div_div_5",
            children: [(hasOccurrences || location) && /*#__PURE__*/_jsxs("div", {
              className: style.metaWrapper,
              "data-id": "deck-card_index_DeckCard_div_6",
              children: [hasOccurrences && /*#__PURE__*/_jsx(Paragraph, {
                className: style.meta,
                "data-id": "deck-card_index_DeckCard_Paragraph",
                children: summariseOccurrences(occurrences === null || occurrences === void 0 ? void 0 : occurrences.times, occurrences === null || occurrences === void 0 ? void 0 : occurrences.timeZone)
              }), location && /*#__PURE__*/_jsx(Paragraph, {
                className: style.meta,
                "data-id": "deck-card_index_DeckCard_Paragraph_8",
                children: location
              })]
            }), /*#__PURE__*/_jsx(Paragraph, {
              className: style.description,
              "data-id": "deck-card_index_DeckCard_div_Paragraph_9",
              children: body
            })]
          })
        })]
      })
    }))
  });
};

export default DeckCard;